import { Component, inject, OnInit,effect } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../context/storageService';
import { UsertStore } from '../../context/userStore';
import { AuthStore } from '../../authentication/authStore';


@Component({
  selector: 'app-login-oidc',
  template: `<p>Logowanie...</p>`
})
export class LoginOidcComponent {
  router = inject(Router);
  auth = inject(AuthStore);
  userStore = inject(UsertStore);
  sessionStorageService = inject(StorageService);
  
  ngOnInit(): void {
    this.handleOidcCallback();

  }

  private async handleOidcCallback(): Promise<void> {
    try {

      const returnUrl = this.sessionStorageService.get('return_url');
      this.sessionStorageService.remove('return_url');

    } catch (err) {
      console.error('OIDC login error', err);
      this.router.navigate(['/']);
    }
  }
}